import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'src/config';
import { getAuthAccessToken } from 'src/configuration/tokenHandling/authSlice';

const TAG_TYPE_TEMPLATES = 'Templates';
const POST = 'POST';
const DELETE = 'DELETE';
const url = config.backend.templates.TEMPLATES_SERVICE;
const path = config.backend.templates.TEMPLATES_PATH;
const baseQuery = fetchBaseQuery({
    baseUrl: url,
    prepareHeaders: (headers, { endpoint, getState, extra, type }) => {
        headers.set('Accept', 'application/json');
        const token = getAuthAccessToken(getState());
        if (token) {
            headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
});
export const templatesApi = createApi({
    reducerPath: 'templatesApi',
    baseQuery,
    tagTypes: [TAG_TYPE_TEMPLATES],
    endpoints: (builder) => ({
        getTemplates: builder.query({
            // query: () => '/templates-man',
            query: () => path,
            providesTags: [TAG_TYPE_TEMPLATES],
            keepUnusedDataFor: 0, // override the default of 60 seconds
        }),
        postTemplate: builder.mutation({
            query: (request) => ({
                // url: '/templates-man',
                url: path,
                method: POST,
                body: request,
            }),
            invalidatesTags: [TAG_TYPE_TEMPLATES],
        }),
        deleteTemplate: builder.mutation({
            query: (request) => ({
                url: '/templates',
                method: DELETE,
                body: request,
            }),
            invalidatesTags: [TAG_TYPE_TEMPLATES],
        }),
    }),
});

// Export hooks for usage in function components which are auto-generated based on defined endpoints
export const { useGetTemplatesQuery, usePostTemplateMutation, useDeleteTemplateMutation } = templatesApi;
